<template>
<div>
	<p>FOUR OH FOUR</p>
	<p>{{msg}}</p>
</div>
</template>
<script>
export default {
	data () {
		window.console.log()
		return {
			msg: this.$route.path
		}
	}
}
</script>



// WEBPACK FOOTER //
// NotFound.vue?0ee01090